import React from 'react';
import { searchEvent } from '../api/request';
import '../assets/style/price.scss';
import CityDom from './selectCity'
import CountryDom from './selectCountry'
import { Button, Table, Pagination, Loading, Message } from 'element-react/next';
import 'element-theme-default';
import { Link } from 'react-router-dom';

const crumb = {
    home: {
        name: {
            "chinese": "首页",
            "english": "Home"
        },
        url: '/'
    },
    about: {
        name: {
            "chinese": "关于",
            "english": "About"
        },
        url: '/about'
    },
    text: {
        "chinese": "价格查询",
        "english": "Text"
    }
}
export default class Price extends React.Component {
    state = {
        news: {}
    };
    constructor(props) {
        super(props);
        this.state = {
            countryStatus: false,
            cityStatus: false,
            countryName: '',
            countryValue: "",
            length_: null,
            height: null,
            postcode: "",
            randomNum: "",
            cityName: "",
            cityValue: "",
            weights: null,
            width: null,
            tableData: [],
            total: 0,
            fullscreen: false,
            pageNum: 1,
            columns: [
                {
                    label: "",
                    width: 40,
                    prop: "shippingMethodName",
                    render: (row, column, index) => {
                        return (<svg className="icon" aria-hidden="true">
                            <use xlinkHref={row.recommendType == '0' ? "#" : (row.recommendType == '1' ? "#icontuijian" : "#iconremen")}></use>
                        </svg>)
                    }
                },
                {
                    label: "邮寄方式",
                    width: 130,
                    prop: "shippingMethodName"
                },
                {
                    label: "路线",
                    prop: "shippingMethodTagName",
                    width: 160
                },
                {
                    label: "预见时效",
                    width: 100,
                    render: (row, column, index) => {
                        return <span className="color1">{row.effectiveness}</span>
                    }
                },
                {
                    label: "渠道可发",
                    prop: "channelTypeName",
                    width: 160
                },
                {
                    label: "国家",
                    prop: "countryName",
                    width: 108
                },
                {
                    label: "邮编",
                    prop: "postcode",
                    width: 100
                },
                {
                    label: "重量",
                    width: 70,
                    align:"right",
                    render: (row, column, index) => {
                        if (row.weightUnit) {
                            return <span>{row.weight} {row.weightUnit}</span>
                        } else {
                            return <span></span>
                        }

                    }
                },
                {
                    label: "体积",
                    prop: "volume",
                    width: 120,
                    align:"right",

                },
                {
                    label: "体积重",
                    prop: "volumeWeight",
                    width: 90,
                    align:"right",
                    render: (row, column, index) => {
                        if (row.volumeWeight) {
                            return <span>{row.volumeWeight}{row.weightUnit}</span>
                        } else {
                            return <span></span>
                        }
                    }
                },
                {
                    label: "预估价格",
                    prop: "price",
                    width: 120,
                    align:"right",
                    render: (row, column, index) => {
                        if (row.price) {
                            return <span><span className="color1">{row.price}</span>{row.chargeCurrency}</span>
                        } else {
                            return <span></span>
                        }
                    }
                },
                // {
                //     label: "操作",
                //     prop: "zip",
                //     fixed: 'right',
                //     width: 100,
                //     render: () => {
                //         return <span><Button type="text" size="small">联系我</Button></span>
                //     }
                // }
            ],
        }
    }
    renderTable() {
        return (
            <Table
                style={{ width: '100%' }}
                columns={this.state.columns}
                data={this.state.tableData}
                border={true}
            />
        )
    }
    search(num) {
        if (this.state.countryValue == 'US' || this.state.countryValue == 'AU') {
            if (this.state.postcode == '') {
                return Message({
                    message: '邮编为必填项',
                    type: 'warning'
                });
            }
        }
        let data = {
            country: this.state.countryValue,
            height: this.state.height == null ? this.state.height : Number(this.state.height).toFixed(3),
            length: this.state.length_ == null ? this.state.length_ : Number(this.state.length_).toFixed(3),
            postcode: this.state.postcode,
            randomNum: this.state.randomNum,
            sendCity: this.state.cityName,
            weights: this.state.weights == null ? this.state.weights : Number(this.state.weights).toFixed(3),
            width: this.state.width == null ? this.state.width : Number(this.state.width).toFixed(3)
        }
        let size = 10
        this.setState({
            fullscreen: true,
            pageNum: num
        })
        searchEvent('/api/logistics/website/charge/trial?pageSize=' + size + '&pageNum=' + num, data).then(res => {
            if (res.code == 200) {
                this.setState({
                    tableData: res.data.rows,
                    total: res.data.total,
                })
                Message({
                    showClose: true,
                    message: '查询成功',
                    type: 'success'
                });
                this.renderTable()
            } else {
                return Message({
                    showClose: true,
                    message: `${res.msg}`,
                    type: 'error'
                });
            }

        }).finally(() => {
            this.setState({
                fullscreen: false
            })
        })
    }
    componentWillMount() {
        let prevPage = this.props.parent.props.location.query
        if (prevPage) {
            this.setState({
                countryName: prevPage.countryName,
                countryValue: prevPage.countryValue,
                cityName: prevPage.cityName,
                cityValue: prevPage.cityValue,
                length_: prevPage.length_,
                weights: prevPage.weights,
                width: prevPage.width,
                height: prevPage.height,
                postcode: prevPage.postcode
            })
        }
    }
    componentDidMount() {

        this.search(1)
    }
    getChildrenMsg = (result, msg) => {
        this.setState({
            cityName: msg.name,
            cityValue: msg.value,
            cityStatus: false
        })
    }
    getCountryMsg = (result, msg) => {
        this.setState({
            countryName: msg.name,
            countryValue: msg.value,
            countryStatus: false
        })
    }
    change(e, num) {
        if (num == 0) {
            this.setState({
                length_: e.target.value
            })
            return
        }
        if (num == 1) {
            this.setState({
                width: e.target.value
            })
            return
        }
        if (num == 2) {
            this.setState({
                height: e.target.value
            })
            return
        }
        if (num == 3) {
            this.setState({
                postcode: e.target.value
            })
            return
        }
        if (num == 4) {
            this.setState({
                weights: e.target.value
            })
            return
        }
    }
    render() {
        const { language } = this.props.parent.props;
        return (
            <div>
                <img style={{height:240+'px'}} src={require('../assets/image/price_banner.png')} alt="" />
                <div className="pms-price">
                    <div className="page-crumbs">
                        <span><Link to="/">{crumb.home.name[language]}</Link> &gt;</span>
                        <span>{crumb.about.name[language]} &gt;</span>
                        <span>{crumb.text[language]}</span>
                    </div>
                    <div className="pms-price-form">
                        <span className="pms-price-form-title">价格查询</span>
                        <div className="pms-price-form-item">
                            <div className="item item-flex" style={{ marginRight: 20 + "px" }}>
                                <span className="title">发件城市</span>
                                <div className="pms-price-search-right" onClick={() => {
                                    this.setState({
                                        cityStatus: !this.state.cityStatus,
                                        status: 'city',
                                        countryStatus: false
                                    })
                                }}>
                                    <span>{this.state.cityName}</span>
                                    <span className={this.state.cityStatus ? 'triangle1' : 'triangle'}></span>
                                </div>
                                <CityDom className="pms-select" parent={this}></CityDom>
                            </div>

                        </div>
                        <div className="pms-price-form-item">
                            <div className="item item-flex" style={{ marginRight: 20 + "px" }}>
                                <span className="title">目的国家</span>
                                <div className="pms-price-search-right" onClick={() => {
                                    this.setState({
                                        countryStatus: !this.state.countryStatus,
                                        status: 'country',
                                        cityStatus: false
                                    })
                                }}>
                                    <span>{this.state.countryName}</span>
                                    <span className={this.state.countryStatus ? 'triangle1' : 'triangle'}></span>
                                </div>
                                <CountryDom className="pms-select" parent={this}></CountryDom>
                            </div>
                            <div className={(this.state.countryValue == 'US' || this.state.countryValue == 'AU') ? "item item-flex" : "item-off"} style={{ marginLeft: 20 + "px" }}>
                                <span className="title">邮编</span>
                                <div className="pms-price-search-right" >
                                    <input style={{ width: 88 + "%", backgroundColor: "#fff" }} value={this.state.postcode} onChange={(event) => { this.change(event, 3) }}></input>
                                    <span className="span"></span>
                                </div>
                            </div>
                        </div>
                        <div className="pms-price-form-item">
                            <div className="item item-flex" style={{ marginRight: 20 + "px" }}>
                                <span className="title">重量</span>
                                <div className="pms-price-search-right" >
                                    <input style={{ width: 90 + "%", backgroundColor: "#fff" }} value={this.state.weights} onChange={(event) => { this.change(event, 4) }}></input>
                                    <span className="span">KG</span>
                                </div>
                            </div>
                            <div className="item item-flex" style={{ marginLeft: 20 + "px" }}><span className="title">包裹体积</span>
                                <div className="pms-price-search-right">
                                    <input type="input" placeholder="" onChange={(event) => { this.change(event, 0) }} ref="city" value={this.state.length_} />CM&nbsp;&nbsp;&nbsp;x
					<input type="input" style={{paddingLeft:10+"px"}} placeholder="" onChange={(event) => { this.change(event, 1) }} ref="city" value={this.state.width} />CM&nbsp;&nbsp;&nbsp;x
					<input type="input" style={{paddingLeft:10+"px"}} placeholder="" onChange={(event) => { this.change(event, 2) }} ref="city" value={this.state.height} />CM
                                </div>
                            </div>
                        </div>
                        <botton className="btn" onClick={() => {
                            this.setState({
                                pageNum: 1
                            })
                            this.search(1)
                        }
                        }>查询</botton>
                    </div>
                    <div>{this.renderTable()}</div>
                    <Pagination layout="total, prev, pager, next" small={true} total={this.state.total} currentPage={this.state.pageNum} onCurrentChange={
                        (pageNo) => {
                            this.search(pageNo)
                        }
                    } />
                    <div>{
                        this.state.fullscreen && <Loading fullscreen={true} />}
                    </div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./public/views/price.js